/**
 * 解决Spin组件无法覆盖全部的下层事件，spin存在maxheight
 */
import React from 'react';
import { Spin } from 'antd';

export default function LoadingCover(props) {
    return (
        <Spin spinning={props.spinning}>
            {props.spinning && <div style={{position:'absolute',width:'100%',height:'100%',left:0,top:0,zIndex:1}}></div>}
            {props.children}
        </Spin>
    );
}



// WEBPACK FOOTER //
// ./src/components/LoadingCover/index.js